// extracted by mini-css-extract-plugin
module.exports = {"payment-desktop":"PaymentDesktop_payment-desktop__2tNyj","App":"PaymentDesktop_App__2JMBg"};